import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from '@/shared/i18n';
import {Formatter, SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
import moment from 'moment';

export default class DpvSearch extends BaseModel {
  auction_number = null;
  auctionDateRange = {startDate: null, endDate: null};
  buyer_number = null;
  buyer_first_name = null;
  buyer_last_name = null;
  invoice_number = null;
  dpv_number = null;
  dateRange = {startDate: null, endDate: null};

  attributeLabels = {
    auction_number: i18n.t('Sale No'),
    buyer_number: i18n.t('Customer'),
    buyer_first_name: i18n.t('First Name'),
    buyer_last_name: i18n.t('Last Name'),
    invoice_number: i18n.t('Invoice'),
    dpv_number: i18n.t('DPV Number')
  }

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }
    if (this.auctionDateRange.startDate) {
      data.auction_date_after = moment(this.auctionDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.auction_date_before = moment(this.auctionDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }
    delete data.dateRange;
    delete data.auctionDateRange;

    return data;
  }
}
